/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 30/9/2020
 */
import BaseObject from "@shared/BaseObject.js";
import AuthManager from "@/core/js/backend/AuthManager";
import {RoleEnum} from "@/core/js/model/Permissions/RoleEnum.js";
import {RedirectCookie} from "@/core/js/Cookie/RedirectCookie";
import {AccountTypeEnum} from "@shared/Subscription/AccountTypeEnum.js";
import UserSubscription from "@shared/Subscription/UserSubscription.js";
import {plainToClass} from "@qwoach/class-transformer-wrapper";
import {isAppTheraLogik} from "@/utils/helpers";

export default class RouterManager extends BaseObject {

	authManager: AuthManager
	router

	constructor(router, authManager, store, options = {}) {
		super();
		this.router = router;
		this.store = store;
		this.authManager = authManager;
		this.redirectCookie = new RedirectCookie()
		this.options = options;

		this.setup()
	}

	setup(){
		this.router.beforeEach(async (to, from) => {
			//we need to wait for the token to be set before we can proceed
			// because redirectGuard relies on login state which is set after the token is set
			await this.waitForTokenSet() //this wait prevents routerManager.router.isReady() to be resolved in main.js, but I'm not sure now why do we need it in the first place

			return this.generalRedirectGuard(to, from)
		})
	}



	async loginSaveOrRestoreRoute(to, from){
		let isToLogin = (to.name || "").indexOf("Login") >= 0
		let isFromLogin = (from.name || "").indexOf("Login") >= 0
		let pathFrom = (from.path || "/")
		console.log("RouterManager loginSaveOrRestoreRoute: isToLogin = ", isToLogin, ", isFromLogin = ", isFromLogin, ", pathFrom = ", pathFrom)
		if(isToLogin && isFromLogin || !isToLogin && !isFromLogin || pathFrom === "/"){
			return false
		}
		// if(isToLogin){
		// 	console.log("RouterManager loginSaveOrRestoreRoute: isToLogin = true")
		// 	// this.redirectCookie.saveRedirectPath(from.path)
		// 	return false
		// }
		if(isFromLogin){
			let redirectUrl = this.redirectCookie.getAndClear()
			console.log("RouterManager loginSaveOrRestoreRoute: isFromLogin = true, redirectUrl = ", redirectUrl)
			if(redirectUrl){
				return redirectUrl
			}
			return false
		}
	}



	redirect(path, to, from){
		if (to.path !== path) {
			return {path}
		}
		return false
	}


	redirectExpired(to, from){
		let userProfile = this.authManager.getUserProfile()
		let userRole = userProfile ? userProfile.currentPortalRef.role : null;
		let userSubscription = this.getUserSubscription()
		if(userRole === RoleEnum.COACH && (!userSubscription || !userSubscription.isAccessValid())) {
			console.log("RouterManager generalRedirectGuard: account expired: from.path = ", from.path)
			let name = "ProfileSubscriptionRoute"
			if(this.isQwoachV2App()){
				name = "RecoveryProfileSubscriptionRoute"
			}
			if(to.name === name){
				return false
			}
			return {name}
		}
	}

	isQwoachV2App(){
		console.log("RouterManager.isQwoachV2App: isAppTheraLogik = ", isAppTheraLogik)
		if(isAppTheraLogik){
			return false;
		}
		return this.authManager.isQwoachV2App()
	}

	async generalRedirectGuard(to, from){
		console.log("RouterManager generalRedirectGuard: to = ", to, ", from = ", from)
		let isQwoachV2 = this.isQwoachV2App()
		let userRole = this.authManager.getUserRole();
		let isLoggedIn = this.authManager.isLoggedIn()
		let isWhitelisted = this.isWhitelistedFn(to, from)
		let requiredRole = this.getRequiredRole(to)

		let userSubscription = this.getUserSubscription()

		// if(!this.isInvitedClient()){
		// 	return await this.logout()
		// }

		if(userSubscription && userSubscription.accountType === AccountTypeEnum.GENOGRAM
			&& to.name === "DashboardListRoute"){
			return this.redirectToClients(to, from)
		}

		let res = this.shouldRedirectToRecovery(to, from)
		if(res){
			return res
		}

		console.log("RouterManager generalRedirectGuard: requiredRole = ", requiredRole, ", userRole = ", userRole, ", isLoggedIn = ", isLoggedIn, ", isWhitelisted = ", isWhitelisted, ", isQwoachV2 = ",isQwoachV2)

		if(isWhitelisted){
			console.log("RouterManager isWhitelisted - proceed")
			return true
		}

		if(!isLoggedIn){
			console.log("RouterManager generalRedirectGuard: not logged in - redirecting to login...")
			return this.redirectToLogin()

		}

		res = this.redirectExpired(to, from)
		console.log("RouterManager generalRedirectGuard: redirectExpired = ", res)
		if(res){
			return res
		}





		let newPath = this.syncPathWithRole(to, userRole, isQwoachV2)
		if(newPath){
			console.log("RouterManager generalRedirectGuard: path synced with role: newPath = ", newPath)
			return newPath
		}


		if(!requiredRole || userRole === requiredRole){
			console.log("RouterManager generalRedirectGuard: role permitted - allow")
			return true
		}
		if(userRole === RoleEnum.COACH) {
			console.log("RouterManager generalRedirectGuard: redirect to the default coach location")
			return {name: 'CoachMain'}//'/app/coaching/processes'
		}
		if(userRole === RoleEnum.CLIENT) {
			console.log("RouterManager generalRedirectGuard: redirect to the default client location")
			return isQwoachV2 ? {name: 'ClientMain'} : {name: 'ClientPortalOldRouteName'}//'/cl/coaching/processes'
		}
		console.log("RouterManager generalRedirectGuard: no route found. redirecting to login...")

		return this.redirectToLogin()
	}

	// isInvitedClient(){
	// 	if(this.authManager.isClient()){
	// 		let isQwoachV2 = this.isQwoachV2App()
	// 		let userProfile = this.authManager.getUserProfile()
	// 		if(isQwoachV2 && !userProfile.portalRef){
	// 			return false
	// 		}
	// 	}
	// 	return true
	//
	// }
	redirectToClients(to, from){
		return {name: "ClientListMainRoute"}
	}

	shouldRedirectToRecovery(to, from){
		let isQwoachV2 = this.isQwoachV2App()
		if(isQwoachV2 && to.path.indexOf("app/coaching") >= 0){
			console.log("RouterManager RouterManager redirect to recovery")
			return {name: 'CoachMain'}//'/recovery'
		}
		if(isQwoachV2 && to.path.indexOf("cl/coaching") >= 0){
			console.log("RouterManager redirect to portal")
			return {name: 'ClientMain'}//'/portal'
		}
		return false

	}


	getUserSubscription(){
		if(this.store){
			let store = this.store.state.store
			return plainToClass(UserSubscription, store.ownerSubscription || store.userSubscription);
		}
		return null
	}

	waitForTokenSet(){
		return new Promise(resolve => {

			let isTokenSet = this.store ? this.store.state.store.isTokenSet : true;

			if(isTokenSet){
				console.log("RouterManager isTokenSet router from state = true")
				resolve()
				return
			}
			console.log("RouterManager isTokenSet router false. waiting...")

			let unsubscribe
			unsubscribe = this.authManager.startListenForLoginStateChange(async (userProfile, error) => {
				this.store.commit('setIsTokenSet', true)
				if(unsubscribe) {unsubscribe()}
				resolve()
			})

		})
	}


	getRequiredRole(to){
		let isCoachRoleRequired = to.matched.some(x => x.meta.coachAuth);
		let isClientRoleRequired = to.matched.some(x => x.meta.clientAuth);

		if (isCoachRoleRequired) {
			return RoleEnum.COACH
		}
		if (isClientRoleRequired) {
			return RoleEnum.CLIENT
		}
		return null
	}

	redirectToLogin(){
		let name = this.authManager.getLoginPathName()
		// let loginUrl = this.router.resolve({name: name}).href
		console.log("RouterManager logout: name = ", name)//, ", loginUrl = ", loginUrl)
		return {name}
	}

	isWhitelistedFn(to, from){
		const isWhitelisted = to.matched.some(x => x.meta.isWhitelisted || false)
		return isWhitelisted
	}

	syncPathWithRole(to, role, isQwoachV2){
		if(role === RoleEnum.CLIENT && to.path.startsWith("/app/")){
			return isQwoachV2 ? {name: 'ClientMain'} : {name: 'ClientPortalOldRouteName'}//to.path.replace("/app/", "/cl/")
		}
		if(role === RoleEnum.COACH && to.path.startsWith("/cl/")){
			return {name: 'CoachMain'}//to.path.replace("/cl/", "/app/")
		}
	}

}

